module.exports = __webpack_public_path__ + "static/media/maps.558e006b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Restaurant/maps.jpg
// module id = 346
// module chunks = 0